import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { useEffect } from "react";

import { Drawer } from "~/components/common/drawer";
import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import { useDocumentBodyScrollLock } from "~/lib/hooks";
import { rosettaAtom } from "~/lib/rosetta";
import { ZIndexLayer } from "~/lib/styles";

import { StyledSubscriptionWidget } from "./styles";

export const PostiesPaywallContainer: FunctionComponent = () => {
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const { lockDocumentBodyScroll } = useDocumentBodyScrollLock();

  const shouldShowPaywall =
    asyncRosettaState?.status === "success" &&
    !asyncRosettaState?.result?.hasPostiesAccessRight &&
    asyncRosettaState?.result?.contentServiceUserInfo?.isSubscriptionEnabled === true;

  useEffect(() => {
    if (!shouldShowPaywall) return;

    sendGATracking({
      action: "Subscribe to SCMP/Posties paywall/Impression",
      category: "Subscribe to SCMP",
      label: window.tp?.customVariables?.paywallCampaign ?? "",
    });
  }, [shouldShowPaywall]);

  useEffect(() => {
    if (!shouldShowPaywall) return;

    lockDocumentBodyScroll(true);

    return () => lockDocumentBodyScroll(false);
  }, [lockDocumentBodyScroll, shouldShowPaywall]);

  if (!shouldShowPaywall) {
    return null;
  }

  return (
    <Drawer
      anchor="bottom"
      open={true}
      PaperProps={{
        sx: {
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        },
      }}
      sx={{
        zIndex: `${ZIndexLayer.AppBar - 1}`,
      }}
    >
      <StyledSubscriptionWidget variant="paywall" />
    </Drawer>
  );
};

PostiesPaywallContainer.displayName = "PostiesPaywallContainer";
